import * as React from "react";

import translate from "@insite/client-framework/Translate";
import Pagination from "@thkStore/Widgets/ProductList/CustomPagination";
import styled from "styled-components";

interface VariantPaginationProps {
    totalResults: number;
    currentPage: number;
    pageSize: number;
    pageSizeOptions: number[];
    onPageChange: (page: number) => void;
    onPageSizeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const PaginationContainer = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: center;
`;

export const VariantPagination: React.FC<VariantPaginationProps> = ({
    totalResults,
    currentPage,
    pageSize,
    pageSizeOptions,
    onPageChange,
    onPageSizeChange,
}) => {
    if (totalResults <= 0) {
        return null;
    }

    return (
        <PaginationContainer>
            <Pagination
                resultsCount={totalResults}
                currentPage={currentPage}
                resultsPerPage={pageSize}
                resultsPerPageOptions={pageSizeOptions}
                onChangePage={onPageChange}
                onChangeResultsPerPage={onPageSizeChange}
                resultsPerPageLabel={translate("Results Per Page")}
            />
        </PaginationContainer>
    );
};
